(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // Translate the existing Depo label; keep its radio, option ID and calculated amount intact.
 function fansTranslateDeposit() {
   const source = document.querySelector('[data-fans-deposit-label]');
   if (!source) return;
   document.querySelectorAll('.depo-pp-label').forEach((label) => {
     const original = label.textContent;
     if (!original.trim().startsWith('30% betalen als voorschot.')) return;
     const parts = original.split('Je betaalt nu');
     if (parts.length !== 2) return;
     const amount = parts[1].replace(/^\s*[-–]\s*/, '').trim();
     label.textContent = source.dataset.fansDepositLabel + amount;
   });
 }
 let fansDepositQueued = false;
 const fansDepositObserver = new MutationObserver(() => {
   if (fansDepositQueued) return;
   fansDepositQueued = true;
   requestAnimationFrame(() => { fansDepositQueued = false; fansTranslateDeposit(); });
 });
 fansTranslateDeposit();
 fansDepositObserver.observe(document.querySelector('main') || document.body, {childList:true, subtree:true, characterData:true});
  } catch(e) { console.error(e); }
})();

})();
